import { FC } from 'react';

export type SectionHeadingGroupProps = {
  className?: string;
  title: string;
  subtitle: string;
};

export const SectionHeadingGroup: FC<SectionHeadingGroupProps> = ({
  className,
  title,
  subtitle,
}) => (
  <hgroup className={className}>
    <h2 className="mb-1 text-base/7 font-semibold">{title}</h2>
    <p className="text-sm/6 text-gray-600">{subtitle}</p>
  </hgroup>
);
